var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsBoolean, IsDateString, IsNumber, IsOptional, IsString } from 'class-validator';
/**
 * One pending `CancellationFee` row, enriched for the Sammel-Ausfallrechnung
 * modal (TM-9134 #864). Loaded lazily on modal-open via
 * `GET /cancellation-fees/pending?treatmentPlanId=…`, never packed into the
 * billing-lane task params.
 */
export class PendingCancellationFeeRowDto {
    id;
    amountNet;
    currency;
    /** Scheduled start of the missed appointment, ISO-8601. */
    appointmentDate;
    /** Heilmittel name resolved from the linked TreatmentUnit (falls back to a placeholder). */
    heilmittelName;
    /** Days since the fee was raised. */
    daysOpen;
    /**
     * Issuability gate result — `true` means this row is selectable for the
     * batch Berechnen. `Erlassen` stays available regardless.
     */
    canCharge;
    /** German UI copy for the disabled-Berechnen tooltip; `null` when chargeable. */
    blockedReason;
}
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], PendingCancellationFeeRowDto.prototype, "id", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], PendingCancellationFeeRowDto.prototype, "amountNet", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], PendingCancellationFeeRowDto.prototype, "currency", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", String)
], PendingCancellationFeeRowDto.prototype, "appointmentDate", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], PendingCancellationFeeRowDto.prototype, "heilmittelName", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], PendingCancellationFeeRowDto.prototype, "daysOpen", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], PendingCancellationFeeRowDto.prototype, "canCharge", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], PendingCancellationFeeRowDto.prototype, "blockedReason", void 0);
//# sourceMappingURL=pending-cancellation-fee.response.dto.js.map